'use strict';

exports.__esModule = true;
var PATH_TO_SPRITE = exports.PATH_TO_SPRITE = '/icons/svg-icons.svg';


// WEBPACK FOOTER //
// ./components/svg-icon/lib/utils/constants.js